const B_1 = [
    {
        title: '发布招标公告',
        path: '/bidding/projectflow/fabiao/zbgg/jsgc/list'
    }
]
export default {
    path: 'jsgc',
    component: () => import(/*webpackChunkName: 'bidding-projectflow-fabiao-zbgg-jsgc'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/fa/zbgg/jsgc/list'),
            meta: {
                title: '招标公告列表',
                bread: B_1
            },
        }
    ]
}